export const generateRcIframe = ({ selectedLink }) => {
  return `<iframe src='${selectedLink}' width=1200 height=850/>`
}
